/**
 * gradeNumの値を該当の学年を表す文字列に変換
 * gradeNum = 13 = 中学一年生,
 * gradeNum = 14 = 中学二年生,
 * gradeNum = 15 = 中学三年生,
 * ...
 */
export const ChangeFromGradeNumToString = (gradeNum: number): string => {
  switch (gradeNum) {
    case 13:
      return "中学1年生";
    case 14:
      return "中学2年生";
    case 15:
      return "中学3年生";
    case 16:
      return "高校1年生";
    case 17:
      return "高校2年生";
    case 18:
      return "高校3年生";
    case 19:
      return "大学1年生";
    case 20:
      return "大学2年生";
    case 21:
      return "大学3年生";
    case 22:
      return "大学4年生";
    case 23:
      return "大学5年生";
    case 24:
      return "大学6年生";
    case 25:
      return "高専1年生";
    case 26:
      return "高専2年生";
    case 27:
      return "高専3年生";
    case 28:
      return "高専4年生";
    case 29:
      return "高専5年生";
    case 30:
      return "高専6年生";

    default:
      return "";
  }
};
